import n from "./index205.mjs";
import g from "./index331.mjs";
import i from "./index329.mjs";
import h from "./index212.mjs";
import p from "./index332.mjs";
function l(o, s) {
  h(2, arguments);
  var e = n(o), r = n(s), f = i(e, r), t = Math.abs(g(e, r)), a;
  if (t < 1)
    a = 0;
  else {
    e.getMonth() === 1 && e.getDate() > 27 && e.setDate(30), e.setMonth(e.getMonth() - f * t);
    var m = i(e, r) === -f;
    p(n(o)) && t === 1 && i(o, r) === 1 && (m = !1), a = f * (t - Number(m));
  }
  return a === 0 ? 0 : a;
}
export {
  l as default
};
//# sourceMappingURL=index253.mjs.map
